import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { selectLanguage } from '../../store/selectors/language.selector';
import { NgFor } from '@angular/common';
import { changeLanguage } from '../../store/actions/language.action';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language-dropdown',
  standalone: true,
  imports: [NgFor, NgbDropdownModule],
  templateUrl: './language-dropdown.component.html',
  styleUrl: './language-dropdown.component.scss',
})
export class LanguageDropdownComponent implements OnInit {
  private store: Store = inject(Store);
  private translateService: TranslateService = inject(TranslateService);
  private destroyRef: DestroyRef = inject(DestroyRef);
  @Input()isAuth: boolean = false;
  activeLanguage$ = this.store.select(selectLanguage);
  activeLanguage: string = 'test';

  languages: { language: string }[] = [{ language: 'en' }, { language: 'it' }];

  changeLanguage(selectedLanguage: { language: string }) {
    this.store.dispatch(changeLanguage(selectedLanguage));
  }
  ngOnInit(): void {
    this.activeLanguage$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((language) => (this.activeLanguage = language));
    const currentLanguage$ = this.store.select(selectLanguage);
    currentLanguage$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((language: string) => {
        this.translateService.setDefaultLang(language);
        this.translateService.use(language);
      });
  }
}
